import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  author: string;
  cover: string;
  categories: string[];
  status: 'ongoing' | 'completed';
  rating: number;
  views: number;
  isHot?: boolean;
  isNew?: boolean;
}

const categoryNameMap: Record<string, string> = {
  campus: '校园',
  office: '职场',
  fantasy: '奇幻',
  historical: '古风',
  modern: '现代',
  mature: '成熟',
  comedy: '搞笑',
  drama: '剧情',
  romance: '纯爱',
};

export default function ComicCard({
  id,
  title,
  author,
  cover,
  categories: comicCategories,
  status,
  rating,
  views,
  isHot,
  isNew,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02]"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />

        {isHot && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
            热门
          </span>
        )}
        {isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
            新作
          </span>
        )}

        <span
          className={`absolute top-2 right-2 text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
            status === 'ongoing'
              ? 'bg-accent-500/90 text-background-50'
              : 'bg-foreground-700/80 text-background-50'
          }`}
        >
          {status === 'ongoing' ? '连载中' : '已完结'}
        </span>

        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
          <span className="text-xs text-background-50/90 flex items-center gap-1">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
            {rating}
          </span>
          <span className="text-xs text-background-50/80 flex items-center gap-1">
            <i className="ri-eye-line text-xs"></i>
            {formatViews(views)}
          </span>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{author}</p>
        <div className="flex flex-wrap items-center gap-1 mt-2">
          {comicCategories.slice(0, 2).map((cat) => (
            <span
              key={cat}
              className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {categoryNameMap[cat] || cat}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}